exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright[data-v-f6fab1be]{font-size:.875em;padding:1em 0}.grey[data-v-f6fab1be]{background-color:#e5e5e5}footer address[data-v-f6fab1be]{margin-bottom:0}footer a[data-v-f6fab1be]{color:#fff}.contact[data-v-f6fab1be]{padding:.5em 0}.contact[data-v-f6fab1be],.contact a[data-v-f6fab1be]{color:#575757}.contact p[data-v-f6fab1be]{margin-bottom:.4em}@media print{footer[data-v-f6fab1be]{display:none}}", ""]);

// exports
